import { Card } from '@/components/ui/card';
import { BookOpen, Check, ShieldCheck } from 'lucide-react';
import { useTranslation } from '@/i18n/i18n';

export const KISBenefit = () => {
  const { t } = useTranslation();

  return (
    <section className="py-16 px-6 md:px-8 bg-card">
      <div className="max-w-4xl mx-auto">
        <Card className="p-8 md:p-12 bg-card border border-foreground/20 shadow-sm relative overflow-hidden">
          {/* Subtle glow */}
          <div className="absolute top-0 right-0 size-48 bg-primary/10 rounded-full blur-3xl" />

          <div className="relative">
            <div className="text-center mb-8">
              <div className="icon-container mx-auto mb-6">
                <BookOpen className="size-6" />
              </div>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold mb-4 tracking-tight">
                {t('kis.heading')
                  .split('<primary>')
                  .map((part, i) => {
                    if (i === 0) return part;
                    const [primary, rest] = part.split('</primary>');
                    return (
                      <span key={primary}>
                        <span className="font-extrabold text-primary">{primary}</span>
                        {rest}
                      </span>
                    );
                  })}
              </h2>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                {t('kis.subheading')}
              </p>
            </div>

            <div className="bg-background p-6 rounded-xl border border-border/50">
              <h3 className="font-semibold text-foreground mb-4">{t('kis.listTitle')}</h3>
              <ul className="space-y-3">
                {[t('kis.item1'), t('kis.item2'), t('kis.item3')].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <div className="size-5 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <Check className="size-3 text-primary" />
                    </div>
                    <span className="text-muted-foreground">{item}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-5 pt-5 border-t border-border/60 flex flex-col sm:flex-row gap-3 sm:items-center">
                <span className="inline-flex size-8 rounded-lg bg-primary/10 items-center justify-center flex-shrink-0">
                  <ShieldCheck className="size-4 text-primary" />
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground">{t('kis.authorityLine')}</p>
                </div>
              </div>
            </div>

            <p className="text-base font-medium text-foreground text-center mt-6">
              {t('kis.bottomLine')}
            </p>
          </div>
        </Card>
      </div>
    </section>
  );
};
